/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__api_client_mjs_6a0489f6__ from "./api-client.mjs";
var __webpack_exports__DuckDuckGoSearchClient = __WEBPACK_EXTERNAL_MODULE__api_client_mjs_6a0489f6__.DuckDuckGoSearchClient;
export { __webpack_exports__DuckDuckGoSearchClient as DuckDuckGoSearchClient };
